import { nonNegativeInteger, nonNegativeNumber, positiveNumber, postiveNumberZeroToOneHundred } from "@/utils/form";
import { ServiceAdvancedCostParametersSchema } from "./ServiceAdvancedCostParameters";
import { z } from "zod";
import { t } from "i18next";

const PermanentServiceACPSchema = ServiceAdvancedCostParametersSchema.omit({
  carCostsPerMinute: true,
  otherCostsPerMinute: true,
});

export const EditPermanentServiceACPModalSchema = z
  .object({
    name: z.string().min(1, t("schemas:form.required")),
    info: z.string().max(500, t("schemas:form.maxlength", { max: 500 })).optional(),
    hourlyWage: positiveNumber(t("permanentservice.inputs.hourlywage.label")),
    hoursBriefingPerEmployee: nonNegativeInteger(
      t("permanentservice.inputs.hoursbriefingperemployee.label")
    ),
    transferredEmployeePercentage: postiveNumberZeroToOneHundred(
      t("permanentservice.inputs.transferredemployeepercentage.label")
    ),
    nonTariffAllowance: nonNegativeNumber(
      t("permanentservice.inputs.nontariffallowance.label")
    ),
    pauseIncluded: z.boolean(),
    acp: PermanentServiceACPSchema,
  });

export type TEditPermanentServiceACPModalSchema = z.infer<typeof EditPermanentServiceACPModalSchema>;
